import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import ProductMappingActionModalContainer from './ProductMappingActionModalContainer';
import {setCategoryProductMappingModal} from '../../../../store/slice/ManufSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '85%', xs: '95%' },
  height: { lg: '85%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function ProductMappingActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {productMappingModalOpen, categoryObj} = useSelector((state)=>state.manufslice.categoryDashboard);

  useEffect(()=>{
  },[productMappingModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setCategoryProductMappingModal(false));
  }
  return (
    <Modal
       open={productMappingModalOpen===undefined?false:productMappingModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  sx={{borderBottom:'1px solid #0050b3'}}>
              Product Mapping @ {categoryObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
            < ProductMappingActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}